import React, { useEffect, useState } from 'react';
import ProductSearch from '../../../components/commonComponents/ProductSearch';
import withNotify from '../../../common/withNotify';
// import Header from '../../../components/Header';
import {
  getProductType,
} from '../../../utils/db';

// import { sortData } from '../../../common/globals';
// import Bugsnag from '../../../helpers/bugsnag';

function SearchByProduct({
  selectedProductKey, onProductSelect
}) {
  const [searchNumber, setSearchNumber] = useState('');
  const [apiController, setApiController] = useState(false);
  const pageSize = 20;

  const [products, setProducts] = useState([]);

  useEffect(() => {
    try {
      const initialPage = 1;
      setProducts([]);

      getSearchedProducts('', initialPage).then((productsResult) => {
        setProducts(productsResult);
      });
    } catch (e) {
      // Bugsnag.notify(e);
    }
  }, []);

  useEffect(() => {
    try {
      const initialPage = 1;
      if (!searchNumber.length) {
        setProducts([]);
        return;
      }

      if (searchNumber.length < 3) return;

      getSearchedProducts(searchNumber, initialPage).then((productsResult) => {
        setProducts(productsResult);
      });
    } catch (e) {
      // Bugsnag.notify(e);
    }
  }, [searchNumber]);

  const getSearchedProducts = async (
    localSearchNumber,
    localPageNumber,
  ) => {
    try {
      if (apiController) {
        setProducts([]);
      }
      setApiController(true);

      const searchData = {};
      if (searchNumber) searchData.productNo = localSearchNumber;
      searchData.page = localPageNumber;
      searchData.size = pageSize;
      const searchResponse = await getProductType(searchData);

      if (searchResponse.length > 0) {
        const responseProducts = searchResponse.sort(
          (a, b) => a.OptionNo.localeCompare(b.OptionNo)
        );

        return responseProducts.map((product) => ({
          number: product.OptionNo,
          description: product.OptionName,
          productKey: selectedProductKey
        }));
      }

      return [];
    } catch (e) {
      // Bugsnag.notify(e);
    }
  };

  return (
    <ProductSearch
      onProductSelect={onProductSelect}
      productNumber={searchNumber}
      setProductNumber={setSearchNumber}
      products={products}
      focusProductNumber
    />
  );
}

export default withNotify(
  SearchByProduct
);
